// src/stores/vehicleStore.js
import { defineStore } from "pinia";
import { vehiclesService } from "@/services/vehiclesService";

export const useVehicleStore = defineStore("vehicleStore", {
  state: () => ({
    vehicles: [],
  }),

  actions: {
    // Busca todos os vehicles da API
    async getTypes() {
      try {
        const response = await vehiclesService.fetchTypes();
        this.vehicles.types = response.data;
        return response.data;
      } catch (error) {
        console.error("Failed to fetch vehicles:", error);
        throw error;
      }
    },

    // Busca um vehicle específico
    async getBrands(typeId) {
      try {
        const response = await vehiclesService.fetchBrands(typeId);
        this.vehicles.brands = response.data;
        return response.data;
      } catch (error) {
        console.error(`Failed to fetch vehicle with id :`, error);
        throw error;
      }
    },

    // Busca um vehicle específico
    async getModels(typeId, brandId) {
      try {
        const response = await vehiclesService.fetchModels(typeId, brandId);
        this.vehicles.models = response.data;
        return response.data;
      } catch (error) {
        console.error(`Failed to fetch vehicle with id :`, error);
        throw error;
      }
    },

    // Busca um vehicle específico
    async getYears(typeId, brandId, modelId) {
      try {
        const response = await vehiclesService.fetchYears(typeId, brandId, modelId);
        this.vehicles.years = response.data;
        return response.data;
      } catch (error) {
        console.error(`Failed to fetch vehicle with id :`, error);
        throw error;
      }
    },

    // Busca um vehicle específico
    async getColors() {
      try {
        const response = await vehiclesService.fetchColors();
        this.vehicles.colors = response.data;
        return response.data;
      } catch (error) {
        console.error(`Failed to fetch vehicle with id :`, error);
        throw error;
      }
    },

    // Busca um vehicle específico
    async getOptionals() {
      try {
        const response = await vehiclesService.fetchOptionals();
        this.vehicles.optionals = response.data;
        return response.data;
      } catch (error) {
        console.error(`Failed to fetch vehicle with id :`, error);
        throw error;
      }
    },

  },
});
